"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _scrolling = _interopRequireDefault(require("../../navigation/scrolling"));

var _helpers = require("../../navigation/scrolling/helpers");

var ST = _interopRequireWildcard(require("./styled"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tabs = /*#__PURE__*/function (_Component) {
  _inherits(Tabs, _Component);

  var _super = _createSuper(Tabs);

  function Tabs(_props) {
    var _this;

    _classCallCheck(this, Tabs);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "getStyles", function () {
      return _this.activeTab.current ? {
        width: _this.activeTab.current.clientWidth,
        left: _this.activeTab.current.offsetLeft
      } : {};
    });

    _defineProperty(_assertThisInitialized(_this), "findActiveTab", function () {
      var children = _this.props.children;
      var currentTab = _this.state.currentTab;
      var childrenArray = [];

      if (children) {
        childrenArray = Array.isArray(children) ? children : [children];
      } // если активная вкладка теперь скрыта


      var activeHeaderItem = currentTab;
      childrenArray.forEach(function (tab) {
        if (tab.props.label == currentTab && tab.props.hidden) {
          activeHeaderItem = childrenArray.find(function (item) {
            return !item.props.hidden;
          }).props.label;
        }
      });

      if (activeHeaderItem != currentTab) {
        _this.setState({
          currentTab: activeHeaderItem
        });

        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "switchTab", function (e, tabLabel) {
      var _e$target$getClientRe = e.target.getClientRects(),
          _e$target$getClientRe2 = _slicedToArray(_e$target$getClientRe, 1),
          rects = _e$target$getClientRe2[0];

      var headerWith = _this.headerRef.current.offsetWidth;
      var tabOffset = rects.left + rects.width;
      var headersScrollLeft = _this.headerRef.current.scrollLeft;
      (0, _helpers.moveButtons)(e, _this.scrolling);

      if (tabOffset > headerWith) {
        _this.headerRef.current.scrollLeft = rects.left;
      }

      if (rects.left < 0) {
        _this.headerRef.current.scrollLeft = headersScrollLeft - Math.abs(rects.left);
      }

      _this.setState({
        currentTab: tabLabel
      });

      if (_this.props.onSwitchTab) {
        _this.props.onSwitchTab(tabLabel);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderHeaders", function () {
      var _this$scrolling, _this$scrolling$scrol;

      var _this$props = _this.props,
          children = _this$props.children,
          justify = _this$props.justify,
          accentColor = _this$props.accentColor,
          withSSR = _this$props.withSSR;
      var content = null;
      var scrollingList = (_this$scrolling = _this.scrolling) === null || _this$scrolling === void 0 ? void 0 : (_this$scrolling$scrol = _this$scrolling.scrollingListRef) === null || _this$scrolling$scrol === void 0 ? void 0 : _this$scrolling$scrol.current;
      if (scrollingList && justify) scrollingList.style.justifyContent = 'space-between';

      var headers = _react["default"].Children.map(children, function (tab, idx) {
        var _tab$props = tab.props,
            label = _tab$props.label,
            badge = _tab$props.badge,
            hidden = _tab$props.hidden,
            props = _objectWithoutProperties(_tab$props, ["label", "badge", "hidden"]);

        var currentTab = _this.state.currentTab;
        var isCurrentTab = label === currentTab;

        if (!withSSR && isCurrentTab) {
          content = tab;
        }

        if (hidden) return null;
        return /*#__PURE__*/_react["default"].createElement(ST.TabsItem, _extends({
          key: idx,
          active: isCurrentTab,
          accentColor: accentColor,
          onClick: function onClick(e) {
            return _this.switchTab(e, label);
          },
          ref: isCurrentTab ? _this.activeTab : null
        }, props), label, badge !== undefined ? /*#__PURE__*/_react["default"].createElement(ST.Badge, null, badge) : null);
      });

      if (withSSR) {
        content = _react["default"].Children.map(children, function (tab, index) {
          return tab.props.label === _this.state.currentTab ? /*#__PURE__*/_react["default"].createElement("div", {
            key: index
          }, tab) : /*#__PURE__*/_react["default"].createElement(ST.HiddenTab, {
            key: index
          }, tab);
        });
      }

      return {
        headers: headers,
        content: content
      };
    });

    var _currentTab = _props.activeTab || false;

    if (_props.children) {
      var children = Array.isArray(_props.children) ? _props.children : [_props.children];
      _currentTab = _currentTab ? _currentTab : children[0].props.label;
    }

    _this.state = {
      currentTab: _currentTab,
      barStyles: {},
      hasScroll: false
    };
    _this.headerRef = /*#__PURE__*/_react["default"].createRef();
    _this.activeTab = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(Tabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.findActiveTab();
      this.setState({
        barStyles: this.getStyles()
      });
      var scrollingListRef = this.scrolling.scrollingListRef.current;

      if (scrollingListRef) {
        scrollingListRef.style.height = '100%';
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var activeTab = this.props.activeTab;
      var barStyles = this.state.barStyles; // если активная вкладка скрыта - найти нескрытую

      if (this.findActiveTab()) {
        return;
      }

      var style = this.getStyles();

      if (JSON.stringify(barStyles) !== JSON.stringify(style)) {
        this.setState({
          barStyles: style
        });
      }

      if (activeTab !== prevProps.activeTab) {
        this.setState({
          currentTab: activeTab
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$renderHeaders = this.renderHeaders(),
          headers = _this$renderHeaders.headers,
          content = _this$renderHeaders.content;

      var _this$props2 = this.props,
          accentColor = _this$props2.accentColor,
          className = _this$props2.className;
      return /*#__PURE__*/_react["default"].createElement(ST.TabsWrapper, {
        className: className
      }, /*#__PURE__*/_react["default"].createElement(ST.TabsHead, null, /*#__PURE__*/_react["default"].createElement(ST.TabsHeader, {
        ref: this.headerRef
      }, /*#__PURE__*/_react["default"].createElement(_scrolling["default"], {
        ref: function ref(scrolling) {
          return _this2.scrolling = scrolling;
        }
      }, /*#__PURE__*/_react["default"].createElement(ST.Bar, {
        style: this.state.barStyles,
        accentColor: accentColor,
        hasScroll: this.state.hasScroll
      }), headers))), content);
    }
  }]);

  return Tabs;
}(_react.Component);

_defineProperty(Tabs, "propTypes", {
  activeTab: _propTypes["default"].any,
  children: _propTypes["default"].array,
  label: _propTypes["default"].string,
  onSwitchTab: _propTypes["default"].func,
  withSSR: _propTypes["default"].bool
});

_defineProperty(Tabs, "defaultProps", {
  onSwitchTab: function onSwitchTab() {}
});

var _default = Tabs;
exports["default"] = _default;